import Vue from 'vue';

import {
	Carousel,
	CarouselItem,
	Image,
	Pagination,
	Breadcrumb,
	BreadcrumbItem,
	MessageBox,
	Tabs,
	TabPane,
	Collapse,
	CollapseItem,
	Icon,
	Loading,
} from 'element-ui';

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Pagination)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Icon)


Vue.use(Loading.directive);

Vue.prototype.$msgbox = MessageBox;
